{
  "Accessibility Menu": "輔助功能菜單",
  "Reset settings": "重置設定",
  "Close": "關閉",
  "Content Adjustments": "內容調整",
  "Adjust Font Size": "調整字體大小",
  "Highlight Title": "標題高亮",
  "Highlight Links": "連結高亮",
  "Readable Font": "易讀字體",
  "Color Adjustments": "色彩調整",
  "Dark Contrast": "高對比度（黑色）",
  "Light Contrast": "高對比度（白色）",
  "High Contrast": "高對比度",
  "High Saturation": "高飽和度",
  "Low Saturation": "低飽和度",
  "Monochrome": "單色",
  "Contrast": "對比",
  "Invert Colors": "反轉顏色",
  "Tools": "更多設定",
  "Reading Guide": "閱讀尺",
  "Stop Animations": "停止閃動",
  "Big Cursor": "放大滑鼠",
  "Increase Font Size": "增加字體大小",
  "Decrease Font Size": "減小字體大小",
  "Letter Spacing": "字母間距",
  "Line Height": "行距",
  "Font Weight": "字重",
  "Dyslexia Font": "閱讀障礙字體",
  "Language": "語言",
  "Open Accessibility Menu": "打開輔助功能菜單",
  "Widget Settings": "小工具設定",
  "Widget Position": "小工具位置",
  "Top Left": "左上角",
  "Top Center": "上方中央",
  "Top Right": "右上角",
  "Center Left": "中央偏左",
  "Center Right": "中央偏右",
  "Bottom Left": "左下角",
  "Bottom Center": "下方中央",
  "Bottom Right": "右下角",
  "Screen Reader": "螢幕閱讀器",
  "Voice Navigation": "語音導覽",
  "Custom Color": "自訂顏色",
  "Change the site's colors": "變更網站色彩",
  "Backgrounds": "背景",
  "Headings": "標題",
  "Contents": "內容",
  "Reset colors": "重設顏色",
  "Image Desaturation": "降低圖片飽和度",
  "Search languages": "搜尋語言",
  "No languages found": "找不到語言",
  "Accessibility Profiles": "無障礙設定檔",
  "Motor Impaired": "動作輔助",
  "Big cursor, voice navigation, and no animations.": "大型游標、語音導覽並停用動畫。",
  "Blind": "視障模式",
  "Screen reader helpers with higher contrast.": "高對比的螢幕閱讀輔助。",
  "Color Blind": "色盲模式",
  "High contrast palette with desaturated media.": "高對比調色盤與降低飽和媒體。",
  "Dyslexia": "閱讀障礙",
  "Friendly font, extra spacing, stronger weight.": "易讀字體、額外間距與較粗字重。",
  "Low vision": "低視力",
  "Dark contrast and 130% magnification.": "深色對比與 130% 放大。",
  "Cognitive & Learning": "認知與學習",
  "Highlights key sections and enables voice help.": "強調重點區塊並啟用語音協助。",
  "Seizure & Epileptic": "防癲癇模式",
  "Stops animations and desaturates imagery.": "停止動畫並降低影像飽和度。",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "閱讀指引、醒目連結與柔和色板.",
  "Widget Size": "小工具大小",
  "Default": "預設",
  "Medium": "中",
  "Small": "小",
  "Color Blindness": "色盲模擬",
  "Protanopia": "紅色盲",
  "Deuteranopia": "綠色盲",
  "Tritanopia": "藍色盲",
  "Achromatopsia": "全色盲",
  "Simulates and assists users with color vision deficiencies.": "模擬並協助色覺障礙使用者。"
}
